import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper";
import "../../css/inner-page/sectionSmsExamples.scss";
import CTA from "../CTA";

export default function Section(props) {
  return (
    <section id="sms-examples">
      <h2 dangerouslySetInnerHTML={{ __html: props.title }}></h2>
      <div className="subtitle-wrapper">
        <div data-aos="fade-up">
          <h3>{props.subtitle}</h3>
          <p>{props.content}</p>
        </div>
        <CTA
          href={props.cta.url}
          title={props.cta.title}
          segmentLocation="SMS"
          segmentBtnName="SMS Marketing strategies"
        />
      </div>

      <Swiper
        modules={[Pagination, Autoplay]}
        pagination={{
          clickable: true,
          el: ".swiper-inner-pagination",
        }}
        spaceBetween={70}
        slidesPerView={1}
        grabCursor={true}
        speed={500}
        duration={500}
        loop={true}
        autoplay={{
          delay: 3000,
          disableOnInteraction: false,
        }}
        breakpoints={{
          768: {
            slidesPerView: 4,
            spaceBetween: 23,
          },
          1024: {
            slidesPerView: 4,
            spaceBetween: 27,
          },
          1440: {
            slidesPerView: 4,
            spaceBetween: 64,
          },
        }}
      >
        {props.examples.map((item, index) => {
          return (
            <SwiperSlide key={index}>
              <img src={item.image_group["1x"]} alt={item.image_group.alt} />
            </SwiperSlide>
          );
        })}
      </Swiper>
      <div className="swiper-inner-pagination"></div>
    </section>
  );
}
